import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "card user-limits" };
const _hoisted_2 = { class: "text-center mb-2" };
import _ from "lodash";
import BigNumber from "bignumber.js";
import UListItem from "@/components/uikit/uComponents/UListItem.vue";
import { computed } from "vue";
import { formatDecimalStatic } from "@/help/decimalStatic";
import { useStore } from "vuex";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UserLimits',
    setup(__props) {
        const store = useStore();
        const auTokens = computed(() => store.getters.tokens);
        const usdToken = computed(() => _.find(auTokens.value, x => x.mnemonicEng.toLowerCase().includes("usd")));
        const defaultToken = computed(() => _.find(auTokens.value, x => x.mnemonicEng.toLowerCase().includes("aed")));
        const investments = computed(() => store.getters["capitals/investments"]);
        const transfersSum = computed(() => {
            let sum = BigNumber(0);
            for (const investment of investments.value) {
                sum = BigNumber(investment.sum).plus(sum);
            }
            return Number(formatDecimalStatic({
                value: sum,
                decimal: defaultToken.value?.decimals,
                indent: 2
            }).replace(/\s+/g, ""));
        });
        const limit = computed(() => Number(process.env.VUE_APP_RETAIL_USER_YEAR_LIMIT) * Number(usdToken.value?.rateDefaultToken));
        const currentLimit = computed(() => limit.value - transfersSum.value);
        const percent = computed(() => {
            const calc = (transfersSum.value / currentLimit.value) || 0;
            return Number(calc.toFixed(0));
        });
        const percentLabel = computed(() => {
            return percent.value == 0 && transfersSum.value > 0 ? "> 0" : percent.value;
        });
        const items = computed(() => [
            {
                label: "Annual limit",
                value: "AED " + formatDecimalStatic({
                    value: limit.value,
                    decimal: 0,
                    indent: 2
                })
            },
            {
                label: "Invested the last 12 months",
                value: "AED " + formatDecimalStatic({
                    value: transfersSum.value,
                    decimal: 0,
                    indent: 2
                })
            },
            {
                label: "Avaliable to invest",
                value: "AED " + formatDecimalStatic({
                    value: currentLimit.value,
                    decimal: 0,
                    indent: 2
                })
            }
        ]);
        return (_ctx, _cache) => {
            const _component_UProgressBar = _resolveComponent("UProgressBar");
            const _component_UList = _resolveComponent("UList");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "header-line" }, [
                    _createElementVNode("div", { class: "fs22" }, " Annual investment limit ")
                ], -1)),
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(percentLabel.value) + " % of limit used ", 1),
                    _createVNode(_component_UProgressBar, {
                        procent: percent.value,
                        green: true
                    }, null, 8, ["procent"]),
                    _createVNode(_component_UList, {
                        gap: "5px",
                        class: "mt-4"
                    }, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
                                return (_openBlock(), _createBlock(UListItem, _mergeProps({ key: index }, { ref_for: true }, item), null, 16));
                            }), 128))
                        ]),
                        _: 1
                    })
                ])
            ]));
        };
    }
});
